import React, { useEffect } from "react"
import {
  Form,
  Label,
  Row,
  Col,
  Input,
  FormFeedback,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import { allStates } from "helpers/utils"

const CummunicationAddress = ({
  openAddress,
  setOpenAddress,
  data,
  setData,
}) => {
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      address_one: "",
      address_two: "",
      address_three: "",
      city: "",
      state: "",
      pin_code: "",
    },
    validationSchema: Yup.object({
      address_one: Yup.string().required("Address Line 1 is required"),
      city: Yup.string().required("City is required"),
      state: Yup.string().required("State is required"),
      pin_code: Yup.string()
        .matches(/^[0-9]{6}$/, "Pin Code must be 6 digits")
        .required("Pin Code is required"),
    }),
    onSubmit: async (values) => {
      setData(values)
      setOpenAddress(false, values)
    },
  })

  useEffect(() => {
    validation.setValues({ ...data })
  }, [data])

  return (
    <>
      <Modal
        size="md"
        isOpen={openAddress}
        toggle={() => setOpenAddress(false, validation.values)}
        centered={true}
      >
        <ModalHeader toggle={() => setOpenAddress(false, validation.values)}>
          Communication Address
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <div>
              <Row className="mb-2">
                <Col xl={12}>
                  <Label className="col-form-label">
                    Address Line 1<span className="error">*</span>
                  </Label>
                  <Input
                    name="address_one"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Address Line 1"
                    value={validation.values.address_one}
                    onChange={validation.handleChange}
                    invalid={validation.errors.address_one}
                  />
                  {validation.errors.address_one ? (
                    <FormFeedback type="invalid">
                      {validation.errors.address_one}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">Address Line 2</Label>
                  <Input
                    name="address_two"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Address Line 2"
                    value={validation.values.address_two}
                    onChange={validation.handleChange}
                    invalid={validation.errors.address_two}
                  />
                  {validation.errors.address_two ? (
                    <FormFeedback type="invalid">
                      {validation.errors.address_two}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">Address Line 3</Label>
                  <Input
                    name="address_three"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Address Line 3"
                    value={validation.values.address_three}
                    onChange={validation.handleChange}
                    invalid={validation.errors.address_three}
                  />
                  {validation.errors.address_three ? (
                    <FormFeedback type="invalid">
                      {validation.errors.address_three}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    City<span className="error">*</span>
                  </Label>
                  <Input
                    name="city"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Enter City"
                    value={validation.values.city}
                    onChange={validation.handleChange}
                    invalid={validation.errors.city}
                  />
                  {validation.errors.city ? (
                    <FormFeedback type="invalid">
                      {validation.errors.city}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col xl={12}>
                  <Label className="col-form-label">
                    State<span className="error">*</span>
                  </Label>

                  <select
                    id="state"
                    name="state"
                    className="form-select"
                    value={validation.values.state}
                    onChange={validation.handleChange}
                  >
                    <option value=""> Select</option>
                    {allStates.map((item, index) => (
                      <option key={`business_type_${index}`} value={item.key}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {validation.errors.state ? (
                    <FormFeedback type="invalid">
                      {validation.errors.state}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    PIN Code
                    <span className="error">*</span>
                  </Label>
                  <Input
                    name="pin_code"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="Enter Pin Code"
                    value={validation.values.pin_code}
                    onChange={validation.handleChange}
                    invalid={validation.errors.pin_code}
                  />
                  {validation.errors.pin_code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.pin_code}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm={12}>
                  <div className="d-flex align-items-center mt-4">
                    <button type="submit" className="btn btn-primary w-100">
                      Confirm Address
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </>
  )
}

export default CummunicationAddress
